import { Link, useMatch, useResolvedPath } from "react-router-dom";
import { BlockchainContext } from "./context/BlockchainContext";
import { useContext } from "react";

export default function Navbar() {
  const { approve, connectWallet, currentAccount } =
    useContext(BlockchainContext);

  return (
    <div className="sidebar_container">
      <div className="sidebarItems">
        <div className="sidebarText" onClick={connectWallet}>
          {" "}
          {!currentAccount
            ? "Connect"
            : `${currentAccount.slice(0, 5)}...${currentAccount.slice(
                currentAccount.length - 4
              )}`}{" "}
        </div>{" "}
      </div>
      <div className="sidebarItems">
        <CustomLink to="/">
          <div className="sidebarText">Home</div>{" "}
        </CustomLink>
      </div>
      <div className="sidebarItems">
        <CustomLink to="/DefiMint">
          <div className="sidebarText">Minting</div>{" "}
        </CustomLink>
      </div>
      <div className="sidebarItems">
        <CustomLink to="/tofu">
          {" "}
          <div className="sidebarText">View NFT</div>{" "}
        </CustomLink>
      </div>{" "}
      <div className="sidebarItems">
        <Link to="/StakeNFT">
          {" "}
          <div className="sidebarText">Stake NFT</div>{" "}
        </Link>
      </div>
      {/* 
      <div className="sidebarItems">
        <Link to="/viewNFT">
          {" "}
          <div className="sidebarText">✅View NFT</div>{" "}
        </Link>
            </div>{" "} 
      <div className="sidebarItems">
        <CustomLink to="/DefiMint">
          <div className="sidebarText">🟠Staking</div>{" "}
        </CustomLink>
      </div>*/}
      {/*      <div className="sidebarItems">
        <Link to="/mint">
          <div className="sidebarText">✅Mint</div>{" "}
        </Link>
      </div>

        <li>
          <Link className="sidebarText" to="/StakeNFT">
            {" "}
            Stake NFT
          </Link>
        </li>{" "}
      <div className="sidebarItems">
        <a href="https://poocoin.app/tokens/0xb8c10ead5e4adbb5cc021f113bd6903a38d74338">
          <div className="sidebarText">📈Chart</div>{" "}
        </a>
      </div>{" "}
      <div className="sidebarItems">
        <a href="https://bscscan.com/address/0xb8c10ead5e4adbb5cc021f113bd6903a38d74338#code">
          <div className="sidebarText">🕵️‍♂️contract</div>{" "}
        </a>
      </div>{" "}
      <div className="sidebarItems">
        <a href="https://t.me/Fantasy NFTPortal">
          <div className="sidebarText">Telegram</div>{" "}
        </a>
      </div>{" "}
      <div className="sidebarItems">
        <a href="https://youtube.com/channel/UCvGa0BA1t5pErG4z67Ux_eQ?sub_confirmation=1">
          <div className="sidebarText">Youtube</div>{" "}
        </a>
      </div>{" "}
      <div className="sidebarItems">
        <a href="https://twitter.com/Fantasy NFTBSC">
          <div className="sidebarText">Twitter</div>{" "}
        </a>
      </div>{" "}*/}
    </div>
  );
}
function CustomLink({ to, children, ...props }) {
  const resolvePath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvePath.pathname, end: true });
  const path = window.location.pathname;

  return (
    <div className={path === to ? "sidebarItemActive" : ""}>
      <Link to={to} {...props}>
        {children}
      </Link>
    </div>
  );
}
